import React, { useEffect, useRef } from 'react';
import { Icon } from '../../index';
import './checkbox.scss';


const CheckboxOnly = React.forwardRef(({
    disabled = false,
    error = false,
    indeterminate = false,
    label,
    name,
    onChange,
    onClick,
    required = false,
    size = "sm",
    value,
}, inputRef) => {

    const _inputRef = inputRef ? inputRef : useRef();

    useEffect(() => {
        if (_inputRef && _inputRef?.current) {
            _inputRef.current.indeterminate = indeterminate;
        }

        return () => {};
    }, [indeterminate, value]);

    const iconSize = {
        'sm': 'medium',
        'md': 'medium',
    }

    const handleOnChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    }

    const handleOnClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    }

    const checkboxOnlyClasses = [
        `bsw-checkbox__checkbox`,
        `bsw-checkbox__checkbox--size-${size}`,
        `${indeterminate ? 'bsw-checkbox__checkbox--indeterminate' : value ? 'bsw-checkbox__checkbox--selected' : 'bsw-checkbox__checkbox--inactive'}`,
        `${error ? 'bsw-checkbox__checkbox--error' : ''}`,
        `${disabled ? 'bsw-checkbox__checkbox--disabled' : ''}`
    ].join(' ');

    return (<div className={checkboxOnlyClasses}>
        <input
            aria-label={label}
            checked={value}
            disabled={disabled}
            name={name}
            onChange={handleOnChange}
            onClick={handleOnClick}
            ref={_inputRef}
            required={required}
            type="checkbox"
        />
        {(value || indeterminate) &&
            <div className="bsw-checkbox__checkbox-icon">
                <Icon
                    name={indeterminate ? "minus" : "check"}
                    color="$color-primary-c1"
                    size={iconSize}
                />
            </div>
        }
    </div>)
})

export default CheckboxOnly;